import MyCustomLogoFull from '../../assets/pragma-logo.png';

const LogoFull = () => {
  return <img src={MyCustomLogoFull} alt='Pragma' width={160}  />;
};
export default LogoFull;
